export enum ExtensionType {
  YouTube = "YouTube",
  CommercialExtension = "CommercialExtension",
  PrivateExtension = "PrivateExtension"
}



